<script lang="ts">
  import { session } from '$lib/state/session.svelte';
  import { route } from '$lib/state/route.svelte';
  import { roleProfile } from '$lib/utils/roleProfile';

  function navigate(event: MouseEvent, tab: 'leads' | 'people' | 'activities' | 'my-day' | 'dashboard') {
    event.preventDefault();
    route.push({ tab });
  }
</script>

{#if roleProfile(session.me) === 'coordination'}
  <details class="rounded-2xl border border-[#cfe3e5] bg-[#f2f8f8] px-4 py-3 text-sm">
    <summary class="cursor-pointer font-heading font-bold text-navy">Intake coordinator workspace · how hand-over works</summary>
    <div class="mt-2 space-y-2">
      <p>You handle enquiry intake, assign contacts to the responsible salesperson (Khudoos, Dastageer or Ahad), arrange meetings with that salesperson, and make post-installation satisfaction callbacks.</p>
      <p class="font-semibold">After handover, the assigned salesperson owns the contact. Coordinating a meeting or callback does not automatically make you the sales owner.</p>
      <nav class="flex flex-wrap gap-x-4 gap-y-1" aria-label="Coordinator workflow">
        <a class="text-toyama-teal underline" href="#/leads" onclick={(event) => navigate(event, 'leads')}>1. Review enquiries</a>
        <a class="text-toyama-teal underline" href="#/people" onclick={(event) => navigate(event, 'people')}>2. Assign contacts</a>
        <a class="text-toyama-teal underline" href="#/activities" onclick={(event) => navigate(event, 'activities')}>3. Arrange meetings / callbacks</a>
        <a class="text-toyama-teal underline" href="#/my-day" onclick={(event) => navigate(event, 'my-day')}>Today's follow-ups</a>
        <a class="text-toyama-teal underline" href="#/dashboard" onclick={(event) => navigate(event, 'dashboard')}>Customer care / satisfaction</a>
      </nav>
      <p class="text-xs">For meetings, choose the responsible salesperson as assignee and link the contact. Record the outcome and next step; for satisfaction callbacks, use the existing customer-care confirmation workflow.</p>
    </div>
  </details>
{/if}
